import { render, staticRenderFns } from "./DeletePDFTemplateDialog.vue?vue&type=template&id=eef79108"
import script from "./DeletePDFTemplateDialog.vue?vue&type=script&lang=js"
export * from "./DeletePDFTemplateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports